export const TOKEN_KEY = "api_token";
export const REFRESH_TOKEN_KEY = "api_refresh_token";
export const TOKEN_EXPIRES_AT_KEY = "api_token_expires_at";
